import { render, staticRenderFns } from "./EditApplicantModal.vue?vue&type=template&id=def239c2&"
import script from "./EditApplicantModal.vue?vue&type=script&lang=js&"
export * from "./EditApplicantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports